import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from '../content/header_text.png';
import './HeaderText.css';

/** From Figma — «ДОСТАВКИ», top 145.5 / left 370. */
export function HeaderText() {
  return (
    <SharedHeaderText
      className="delivery-list-header-text"
      src={headerTextImg}
      alt="Доставки"
    />
  );
}
